/* APB founding-members signup — Klaviyo client API.
   v3: fix 400 error — the `subscriptions` object inside profile attributes is
   not accepted by API revision 2024-10-15 (Klaviyo: "'subscriptions' is not a
   valid field for the resource 'profile'"). On a single-opt-in list, the list
   relationship alone subscribes the profile, so that block is removed.
   Verified live 2026-07-07: this exact payload returns 202 Accepted.
   Keeps v2 behavior: single atomic call, one automatic retry, real success
   check, honest error state.
   Editor- and SPA-safe: a single delegated submit listener handles every
   .apb-form on the page, including sections re-rendered by the theme editor. */
(function () {
  if (window.__apbSignupInit) return;
  window.__apbSignupInit = true;

  var COMPANY_ID = "SmjFfS";
  var LIST_ID = "VZ9GuC";
  var REV = "2024-10-15";

  function subscribeCall(payload) {
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY_ID, {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: REV },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error("klaviyo " + res.status);
      return res;
    });
  }

  function field(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : "";
  }

  function showDone(form) {
    var msg = document.createElement("div");
    msg.style.cssText = "text-align:center;padding:6px 0;";
    msg.innerHTML =
      "<div style='font-family:var(--display,sans-serif);font-weight:800;font-size:22px;color:var(--deep-ocean,#0A2540);'>You're in.</div>" +
      "<p style='margin-top:8px;color:var(--muted,#52627A);font-size:15px;'>Welcome to APB. We'll be in touch as the organization takes shape.</p>";
    form.style.display = "none";
    form.parentNode.insertBefore(msg, form);
  }

  function showError(form, msg) {
    var err = form.querySelector(".apb-form-error");
    if (!err) {
      err = document.createElement("p");
      err.className = "apb-form-error";
      err.style.cssText = "margin:8px 0 0;font-size:13px;color:#B4232A;";
      form.appendChild(err);
    }
    err.textContent = msg;
  }

  function handle(form) {
    var email = field(form, "email");
    if (!email) return;
    var name = field(form, "name");
    var country = field(form, "country");
    var role = field(form, "role");

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = "Joining\u2026"; }

    var props = { "Signup Source": "apbglobal splash" };
    if (role) props["APB Role"] = role;
    if (country) props["Country"] = country;

    var profileAttrs = { email: email, properties: props };
    if (name) profileAttrs.first_name = name;

    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "APB Founding Signup",
          profile: { data: { type: "profile", attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: "list", id: LIST_ID } } }
      }
    };

    subscribeCall(payload)
      .catch(function () { return subscribeCall(payload); })
      .then(function () { showDone(form); })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = "Join \u2192"; }
        showError(form, "That didn't go through \u2014 please check your connection and try again.");
      });
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains("apb-form")) return;
      e.preventDefault();
      handle(form);
    },
    true
  );
})();
